// test682
(682 && 0);
